var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          { staticClass: "generic--template page-template bg-brown pb6" },
          [
            _c(
              "div",
              { staticClass: "relative container-fluid mw8 center z-content" },
              [
                _c("section", { staticClass: "row relative center tl" }, [
                  _c(
                    "h1",
                    {
                      staticClass:
                        "f-page-title ttu tl lh-title f2 f1-ns is-blenny is-black",
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.page.title) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "db relative mw6" },
                  [_c("SMSSignupForm")],
                  1
                ),
              ]
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }